<script>
import { Page, Footer } from "@styled/global";

export default {
   render() {
      return (
         <Page>
            <ShadowHeader />
            <Engagement copy="mortgage-engagement" />
            <SingleColumnContent copy="mortgage-subheader" primary />
            <SingleColumnContent copy="mortgage-rates-subheader" color="red" />
            <MortgageRateTable copy="mortgage-rates-table" />
            <Collapsible copy="collapsible-sample1">
               <ContentBlock copy="collapsible-sample1" />
            </Collapsible>
            <AdPanels copy="mortgage-box-ads" />
            <Collapsible copy="collapsible-mortgage-products">
               <BulletSection copy="box-section" />
            </Collapsible>
            <LoanNavigator copy="home-loans-navigator" />
            <ThreeColumnCenterImage copy="three-column-center-image" />
            <Video copy="video" />
            <Faq copy="mortgage-faq" />
            <Footer>
               <Disclosures copy="collapsible-disclosures" />
               <PowerFooter copy="mortgage-power-footer" />
               <FooterNavigation copy="mortgage-footer-navigation" />
               <FooterCopyright copy="copyright" />
            </Footer>
         </Page>
      );
   },
};
</script>
